import { Button, MediaQuery } from '@pelando/components';
import styled from 'styled-components';
import { HEADER_HEIGHT } from '../../../../../components/Header/styles';

export const ProfileHeaderContainer = styled.div`
  display: block;

  &[data-hidden-layout='true'] {
    display: none;
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    height: min-content;
    position: sticky;
    top: ${HEADER_HEIGHT + 16}px;

    &[data-hidden-layout='true'] {
      display: block;
    }
  }
`;

export const ContactButton = styled(Button)`
  display: none;
  @media ${MediaQuery.SCREEN_LG_UP} {
    display: flex;
    width: 100%;
    height: 48px;
    margin-top: 16px;
  }
`;
